import React from "react";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CmtCardFooter from "@coremat/CmtCard/CmtCardFooter";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { useHistory } from "react-router";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import CmtCard from "@coremat/CmtCard";
import TestsRequests from "services/tests";

const useStyles = makeStyles((_) => ({
  cardContainer: {
    marginTop: 10,
  },
  dateText: {
    fontSize: 14,
  },
  assessmentInfoConatiner: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  subtitle: {
    marginTop: 20,
    marginLeft: 5,
  },
  titleIcon: {
    marginRight: 8,
  },
  questionSubtitle: {
    margin: "10px 8px",
  },
}));

const TestElement = ({ data, active }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  let history = useHistory();
  const [openDialog, setOpenDialog] = useState(false);
  const [isActive, setisActive] = useState(false);
  const [statistics, setStatistics] = useState(0);

  useEffect(() => {
    if (active === data._id) {
      setisActive(true);
    } else {
      setisActive(false);
    }
  }, [active]);

  useEffect(() => {
    getContributionStatistics();
  }, [data]);

  const editButtonHandler = () => {
    history.push(`/editTest/${data._id}`);
  };

  const editQuestionsHandler = () => {
    history.push(`/questions/${data._id}`);
  };

  async function getContributionStatistics() {
    try {
      const statitic = await TestsRequests.getQuizContribution(data._id);
      setStatistics(statitic);
    } catch (error) {
      console.log("Error loading statistics:", error);
    }
  }

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleRemoveAndClose = () => {
    setOpenDialog(false);
    dispatch(TestsRequests.deleteTest(data._id));
  };

  const activateQuiz = async () => {
    dispatch(TestsRequests.activate(data._id));
  };

  return (
    <React.Fragment>
      <div className={classes.cardContainer}>
        <CmtCard>
          <CmtCardContent sx={{ pb: 0 }}>
            <Box className={classes.assessmentInfoConatiner}>
              <Box width={"100%"}>
                <Box
                  display={"flex"}
                  justifyContent={"space-between"}
                  width={"100%"}
                >
                  <Typography variant="h3" color="textSecondary" component="h3">
                    {data.title}
                  </Typography>
                  <Box>
                    {isActive && <Chip label="فعال" color="secondary" />}
                    {data.archived && (
                      <Chip
                        style={{ marginRight: "20px" }}
                        label="خزانه"
                        color="primary"
                      />
                    )}
                  </Box>
                </Box>
                <Typography
                  color="textSecondary"
                  className={classes.subtitle}
                  dangerouslySetInnerHTML={{ __html: data.description }}
                ></Typography>
              </Box>
            </Box>
            <br />
            <Box>
              <Typography variant="h4">{`آمار مشارکت : (${statistics})`}</Typography>
            </Box>
          </CmtCardContent>

          <CmtCardFooter
            separator={{
              color: "#bdbdbd",
              borderWidth: 1,
              borderStyle: "solid",
            }}
          >
            <Box>
              <Button
                variant="contained"
                color="primary"
                onClick={() => history.push(`/quizTicketList/${data._id}`)}
                style={{ marginRight: 14, marginTop: 5 }}
              >
                شرکت کنندگان
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => history.push(`/comments/${data._id}`)}
                style={{ marginRight: 14, marginTop: 5 }}
              >
                مشاهده نظرات
              </Button>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<DeleteIcon />}
                onClick={() => setOpenDialog(true)}
                style={{ marginRight: 14, marginTop: 5 }}
              >
                حذف
              </Button>
              <Button
                variant="contained"
                color="primary"
                startIcon={<EditIcon />}
                onClick={editButtonHandler}
                style={{ marginRight: 14, marginTop: 5 }}
              >
                ویرایش
              </Button>
              {!isActive && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={activateQuiz}
                  style={{ marginRight: 14, marginTop: 5 }}
                >
                  فعال سازی
                </Button>
              )}
              <Button
                variant="contained"
                color="primary"
                startIcon={<EditIcon />}
                onClick={editQuestionsHandler}
                style={{ marginRight: 14, marginTop: 5 }}
              >
                ویرایش سوالات
              </Button>
            </Box>
          </CmtCardFooter>
        </CmtCard>
      </div>

      <Dialog
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            آیا از حدف این آزمون اطمینان دارید ؟
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleRemoveAndClose} color="primary">
            تایید
          </Button>
          <Button onClick={handleClose} color="secondary" autoFocus>
            انصراف
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default TestElement;
